module.exports = __webpack_public_path__ + "static/media/main-title-block__arrow.b3b75b43.svg";